import React, { Component } from 'react';
import { connect } from 'react-redux';
import {isEmpty} from "lodash";
import Spinner from '../components/Spinner';
import { getAdvertiser } from '../actions/advertiserActions';
import { getConstants } from "../actions/constantActions";
import IoPage from '../components/IoPage';
import ErrorPage from '../errors/ErrorPage';


class IoCreate extends Component {

  state = {
  };

  componentDidMount() {
    document.title = `GALILEO - Create Order`;
    const { dispatch, match, constants, advertiser } = this.props;
    if (isEmpty(constants)) {
      dispatch(getConstants());
    }
    if (!advertiser) {
      dispatch(getAdvertiser(match.params.id));
    }
  }

  handleClose = value => {
  };

  render() {
    const { isFetching, advertiser, constants, order, error, ...other} = this.props;

    return(
      <div>
        {isFetching && <Spinner />}
        {!isFetching && error && !advertiser && (
          <ErrorPage error={error} entity="advertiser" />
        )}
        {!isFetching && advertiser &&
        (
          <IoPage
            advertiser={advertiser}
            constants={constants}
            error={error}
            {...other}
          />
        )
        }
      </div>
    )
  }
}

const mapStateToProps = state => {
  const { advertiserRequest, orderRequest, constantRequest } = state;
  return {
    isFetching: advertiserRequest.isFetching || orderRequest.isFetching,
    advertiser: advertiserRequest.advertiser,
    constants: constantRequest.constants,
    order: orderRequest.order,
    error: advertiserRequest.error || orderRequest.error
  }
};

export default connect(mapStateToProps)(IoCreate);
